







































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { SettingGroup } from '@/api/com/MetaPattern/APP/MDA/User/SettingGroup';
import { SettingItem } from '@/api/com/MetaPattern/APP/MDA/User/SettingItem';
import { EnumSettingItemType } from '@/api/com/MetaPattern/APP/MDA/User/EnumSettingItemType';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { UserSettingItem } from '@/libs/com/MetaPattern/APP/MDA/User/UserSettingItem';
import { MDAUserService } from '@/api/com/MetaPattern/APP/MDA/User/MDAUserService';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { UserSetting } from '@/api/com/MetaPattern/APP/MDA/User/UserSetting';
import { EnumSettingApply } from '@/api/com/MetaPattern/APP/MDA/User/EnumSettingApply';

@Component({
  components: {
  }
})
export default class Setting extends Vue {
  @Prop() transferData?: any; // 结构：Json，{productId: value; appId: value}
  private key = 0;
  private productId: string = null; // 产品ID
  private appId: string = null; // 应用ID
  expandedList: string[] = [];
  settingItems: Array<UserSettingItem>;
  settingGroup: SettingGroup;

  constructor() {
    super();
    this.settingItems = new Array<UserSettingItem>();
    this.settingGroup = null;
    this.productId = null;
    this.appId = null;
  }

  mounted() {
    if (this.transferData) {
      if (this.transferData.productId) {
        this.productId = this.transferData.productId;
      } else if (this.transferData.appId) {
        this.appId = this.transferData.appId;
      }
    }
  }

  get defaultProps() {
    return {
      children: 'children',
      label: 'label',
      id: 'id',
      isLeaf: 'isLeaf'
    };
  }

  get formData() {
    return { data: this.settingItems };
  }

  get DataType() {
    return EnumSettingItemType;
  }

  get treeData() {
    let settingApply = EnumSettingApply.Global;
    if (this.productId !== null) {
      settingApply = EnumSettingApply.Product;
    } else if (this.appId !== null) {
      settingApply = EnumSettingApply.APP;
    }
    return IDEProgram.instance.getSetting(settingApply, this.transferData === null ? null : this.transferData.product);
  }

  get refreshKey() {
    return this.key;
  }

  getRules(settingItem: SettingItem) {
    const rules: any[] = [];
    if (settingItem.dataType === EnumSettingItemType.Text || settingItem.dataType === EnumSettingItemType.Number || settingItem.dataType === EnumSettingItemType.DateTime ||
      settingItem.dataType === EnumSettingItemType.Date || settingItem.dataType === EnumSettingItemType.Time) {
      rules.push({ required: true, message: '请输入' + settingItem.name, trigger: 'blur' });
    }
    if (settingItem.validateExpression !== null && settingItem.validateExpression !== '') {
      rules.push({ pattern: '^' + settingItem.validateExpression + '$', message: '请输入合法的值', trigger: 'blur' });
    }
    return rules;
  }

  handleNodeClick(node: TreeNode<SettingGroup>, treeNode: any): void {
    console.log('a');
    const items = node.data.settingItems;
    const userSettingItems = new Array<UserSettingItem>();
    items.forEach(item => {
      if (item.selectGroup_ID !== null) {
        const selectGroups = IDEProgram.instance.getSelectGroups();
        const selectGroup = selectGroups.find(group => group.id === item.selectGroup_ID);
        if (selectGroup) {
          item.selectGroup = selectGroup;
        }
      }
      // 获取设置的应用ID
      let appId: string = this.appId;
      if (treeNode.parent !== null && treeNode.parent.parent !== null && treeNode.parent.parent.data.id) {
        appId = treeNode.parent.parent.data.id;
      }
      userSettingItems.push(new UserSettingItem(this.getItemValue(item, this.productId, appId), item, appId));
    });
    this.settingItems = userSettingItems;
    this.settingGroup = node.data;
  }

  // 获取用户的设置值，如果用户未登录或者没有保存设置值，则返回设置项的缺省值
  getItemValue(settingItem: SettingItem, productId: string, appId: string): string | number | string[] {
    let itemValue: string | number | string[] = settingItem.defaultValue;
    if (IDEContext.instance.curUser !== null) {
      const userSetting = IDEContext.instance.curUser.userSettings.find(item => item.settingItem_ID === settingItem.id &&
        (productId === item.productId) &&
        (appId === item.aPPId));
      if (userSetting) {
        itemValue = userSetting.itemValue;
      }
    }
    if (settingItem.dataType === EnumSettingItemType.MultiSelect && settingItem.selectGroup !== null) {
      const result: string[] = [];
      const selectValues = Number(itemValue);
      settingItem.selectGroup.selectOptions.forEach(option => {
        if ((selectValues & option.optionValue) > 0) {
          result.push(option.optionValue.toString());
        }
        itemValue = result;
      });
    }
    return itemValue;
  }

  // 获取是否禁用的标志
  getDisable(item: UserSettingItem): boolean {
    return !item.settingItem.isCustomizable || (item.oldItemValue !== '' && !item.settingItem.isModify);
  }

  // 转换为ItemValue用于保存，处理二级制多选
  toItemValue(userSettingItem: UserSettingItem): string {
    if (userSettingItem.settingItem.dataType === EnumSettingItemType.MultiSelect) {
      const selectedValue = userSettingItem.itemValue as string[];
      let result = 0;
      selectedValue.forEach(selected => {
        result += Number(selected);
      });
      return result.toString();
    }
    return userSettingItem.itemValue.toString();
  }

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        const saved = new Array<UserSetting>();
        const userSettings = IDEContext.instance.curUser.userSettings;
        this.settingItems.forEach(item => {
          const itemValue = this.toItemValue(item);
          const find = userSettings.find(userSetting => userSetting.settingItem_ID === item.settingItem.id &&
            (this.productId === '' || this.productId === userSetting.productId) &&
            (this.appId === '' || this.appId === userSetting.aPPId));
          if (find) {
            if (find.itemValue !== item.itemValue) {
              find.itemValue = itemValue;
              find.persistenceStatus = EnumPersistenceStatus.Update;
              saved.push(find);
            }
          } else {
            const userSetting = new UserSetting();
            userSetting.user_ID = IDEContext.instance.curUser.id;
            userSetting.createdBy = IDEContext.instance.curUser.loginAccountId;
            userSetting.itemValue = itemValue;
            userSetting.settingItem_ID = item.settingItem.id;
            userSetting.persistenceStatus = EnumPersistenceStatus.Create;
            userSetting.productId = this.productId;
            userSetting.aPPId = this.appId;
            if (!userSetting.aPPId || userSetting.aPPId === null) {
              userSetting.aPPId = item.appId;
            }
            saved.push(userSetting);
            userSettings.push(userSetting);
          }
        });
        if (saved.length > 0) {
          MDAUserService.SaveUserSettingsAsync(saved)
            .then((response: Array<UserSetting>) => {
              if (response !== null) {
                response.forEach(userSetting => {
                  const find = userSettings.find(item => item.settingItem_ID === userSetting.settingItem_ID);
                  find.copyFrom(userSetting, false);
                  IDEContext.instance.buildSettings();
                });
                this.$message({ type: 'success', message: '保存成功!' });
              } else {
                this.$message({ type: 'error', message: '保存失败!' });
              }
            })
            .catch(err => {
              this.$message({ type: 'error', message: '保存发生错误，错误信息：' + err });
            });
        }
      } else {
        this.$message({ type: 'error', message: '数据不正确，不能保存!' });
        return false;
      }
    });
  }

  resetForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
  }
}
